<template>
<section class="item-details-section">
    <div>
        <span class="text-semibold">Date range: </span>
        <span>{{ $filters.date(version.starts_on, "MM/DD/YYYY") }}</span>
        <span v-if="version.ends_on"> - {{ $filters.date(version.ends_on, "MM/DD/YYYY") }}</span>
        <span v-else>+</span>
    </div>

    <div>
        <span class="text-semibold">Status: </span>
        <span>{{ status }}</span>
    </div>

    <div>
        <span class="text-semibold">Annual Exemption Limit: </span>
        <span>${{ $filters.formatCurrency(version.exemption_limit) }}</span>
    </div>

    <div>
        <span class="text-semibold">Monthly Exemption: </span>
        <span>${{ $filters.formatCurrency(version.monthly_exemption_limit) }} {{ version.is_credit ? ' (Credit)' : '' }}</span>
    </div>

</section>
</template>

<script>
import InfoWidget from '@/components/InfoWidget'
export default {
    props: ['version', ],
    components: {InfoWidget, },
    computed: {
        status() {
            const STATUSES = {
                'taxable': 'Taxable',
                'subject': 'Subject',
                'exempt': 'Exempt',
            }
            return STATUSES[this.version.status] ? STATUSES[this.version.status] : this.version.status
        },
    },
    data() {
        return {
            isExpanded: false,
        }
    },
}
</script>
